import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import ProductMenu from "../ProductMenu";
import { selectCatalogItem, getAdminCatalogItem, selectOtherCatalogItems, addColor, selectDecorations, selectInventory, selectStyle, selectQuantityPrices } from '../../reducers/catalog';
import { addToCart, cartCount } from '../../reducers/cart';
import { isLoggedIn, isSuperAdmin, getSubsite } from '../../reducers/auth';
import { getMenu } from '../../reducers/menu';
import { useLocation, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import ImageEditModal from '../modals/ImageEditModal';
import CatalogService from '../../services/catalog.service';
import CategoryService from '../../services/category.service';
import LogoService from '../../services/logo.service';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import Accordion from 'react-bootstrap/Accordion';
import { ArrowClockwise, ArrowCounterclockwise, DashLg, PlusLg, Shuffle, Check, Pencil, PlusCircle, XCircle, Asterisk, ShieldLock } from 'react-bootstrap-icons';
import LogoButton from "../LogoButton";
import AddLogoModal from '../modals/AddLogoSetModal';
import AdminService from '../../services/admin.service';
import UserService from '../../services/user.service';
import AddRemoveCategoryModal from "../modals/AddRemoveCatagoryModal";
import CloneProductModal from "../modals/CloneProductModal";
import CategoryList from "../CategoryList";
import AdminImageGallery from './AdminImageGallery';
import SelectDecorationsModal from '../modals/SelectDecorationsModal';
import DuplicateNHKStyleModal from '../modals/DuplicateNHKStyleModal';
import { resolveImageUrl, resolveSwatchUrl } from '../../utils/imageUrl';

const PRICING_TYPES = {
  FLAT: 1,
  QUANTITY: 2,
  BILL_LATER: 3
};

const ProductDetails = () => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  let navigate = useNavigate();
  const dispatch = useDispatch();
  let catalogItem = useSelector(selectCatalogItem);
  const decorations = useSelector(selectDecorations);
  const inventory = useSelector(selectInventory);
  let otherProductItems = useSelector(selectOtherCatalogItems);
  const quantityPrices = useSelector(selectQuantityPrices);
  const itemStatus = useSelector(state => state.catalog.adminItemStatus)
  const [imgSrc, setImgSrc] = useState(null);
  const [imgSrcBack, setImgSrcBack] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentDecorations, setCurrentDecorations] = useState(null);
  const currentStyle = useSelector(selectStyle);
  const [currentColor, setCurrentColor] = useState(null);
  const [currentSize, setCurrentSize] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(null);
  const [currentDragColor, setCurrentDragColor] = useState(null);
  const [currentDragColorSizes, setCurrentDragColorSizes] = useState(new Array());
  const [currentImages, setCurrentImages] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);

  const location = useLocation();
  const loginStatus = useSelector(isLoggedIn);
  const superAdmin = useSelector(isSuperAdmin);
  const [show, setShow] = useState(false);
  const [addSizes, setAddSizes] = useState("");
  const [imageModalShow, setImageModalShow] = useState(false);
  const [selectedDecoration, setSelectedDecoration] = useState(null);
  const [availableColors, setAvailableColors] = useState(null);
  const [selectedColors, setSelectedColors] = useState([]);
  const [logoSrc, setLogoSrc] = useState("");
  const [editedHtmlDescription, setEditedHtmlDescription] = useState('');
  const handleSizeModalClose = () => setShow(false);
  const [showDescription, setShowDescription] = useState(false);
  const handleDescriptionModalClose = () => setShowDescription(false);
  const [descriptionChanged, setDescriptionChanged] = useState(false);
  const [showTitle, setShowTitle] = useState(false);
  const handleTitleModalClose = () => setShowTitle(false);
  const [editedTitle, setEditedTitle] = useState('');
  const [updatedLogos, setUpdatedLogos] = useState("");
  const currentSubsite = useSelector(getSubsite);
  //  const handleShow = () => setShow(true);

  const [selectedLogos, setSelectedLogos] = useState([]);
  const [logosByPosition, setLogosByPosition] = useState([]);
  const [currentLogoPrice, setCurrentLogoPrice] = useState([]);

  const [currentLogoPosition, setCurrentLogoPosition] = useState(null);
  const [updateMode, setUpdateMode] = useState("color");
  const [addLogoModalShow, setAddLogoModalShow] = useState(false);
  const [categoryModalShow, setCategoryModalShow] = useState(false);
  const [cloneProductModalShow, setCloneProductModalShow] = useState(false);

  const [addFeaturedMessage, setAddFeaturedMessage] = useState("");
  const [addFeaturedError, setAddFeaturedError] = useState(false);
  const [logoPosiitonSpinner, setLogoPosiitonSpinner] = useState(false);
  const [priceUpdateSpinner, setPriceUpdateSpinner] = useState(false);
  const [colorUpdateSpinner, setColorUpdateSpinner] = useState(false);
  const [inventoryLoading, setInventoryLoading] = useState(false);
  const [inventoryMessage, setInventoryMessage] = useState(null);

  const [displayedDecorations, setDisplayedDecorations] = useState(null);

  const [markAsNew, setMarkAsNew] = useState(null);
  const [hidden, setHidden] = useState(false);

  const [loading, setLoading] = useState(false);

  // Capability restriction state
  const [capabilities, setCapabilities] = useState([]);
  const [productCapabilities, setProductCapabilities] = useState([]);

  // New Hire Kit decoration selection modal state
  const [showDecorationModal, setShowDecorationModal] = useState(false);
  const [decorationsByLocation, setDecorationsByLocation] = useState([]);
  const [availableLogoSets, setAvailableLogoSets] = useState([]);
  const [pendingNewHireKitId, setPendingNewHireKitId] = useState(null);
  const [newHireKitMessage, setNewHireKitMessage] = useState("");

  // Duplicate NHK style modal state
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [existingNHKItems, setExistingNHKItems] = useState([]);
  const [pendingNHKDecorations, setPendingNHKDecorations] = useState([]);

  // Kit selection modal state
  const [showKitSelectModal, setShowKitSelectModal] = useState(false);
  const [availableKits, setAvailableKits] = useState([]);
  const [loadingKits, setLoadingKits] = useState(false);

  // Logo/Color capability modal state
  const [showLogoCapabilityModal, setShowLogoCapabilityModal] = useState(false);
  const [selectedLogoForCapability, setSelectedLogoForCapability] = useState(null);
  const [logoCapabilityIds, setLogoCapabilityIds] = useState([]); // Array of selected capability IDs
  const [showColorCapabilityModal, setShowColorCapabilityModal] = useState(false);
  const [selectedColorForCapability, setSelectedColorForCapability] = useState(null);
  const [colorCapabilityIds, setColorCapabilityIds] = useState([]); // Array of selected capability IDs
  const [decorationCapabilities, setDecorationCapabilities] = useState({}); // Map of decorationLogoId -> [capabilityIds]
  const [colorCapabilities, setColorCapabilities] = useState({}); // Map of colorId -> [capabilityIds]

  // Personalization state
  const [sizeOverrideModalShow, setSizeOverrideModalShow] = useState(false);
  const [editingSize, setEditingSize] = useState(null);
  const [editingSizeOverride, setEditingSizeOverride] = useState('');
  const [sizeOverrideSaving, setSizeOverrideSaving] = useState(false);
  const [personalizationFields, setPersonalizationFields] = useState([]);
  const [decoColors, setDecoColors] = useState([]);

  const markAsNewChanged = (value) => {
    CatalogService.markAsNew(productId, value);
    setMarkAsNew(value);
  }

  const hiddenChanged = async (value) => {
    await CatalogService.toggleHidden(productId, value);
    setHidden(value);
  }

  let qty = 1;
  let productId = location.state.productId;
  //  let selectedColor = location.state.colorId;


  /*  const qtyChanged = (event) => {
      qty = parseInt(event.target.value);
    }
  ', "cost":', p2.costSingle),
  ', "price2X":', adjust_price_subsite(p2.costSingle2X),
  ', "costSingle2X":', adjust_price_subsite(p2.costSingle2X),
  */

  useEffect(() => {
    console.log("UPDATE CURRENT PRICE", currentLogoPrice, currentItem?.sizes[0].costSingle2X + currentLogoPrice);
    setCurrentPrice((currentItem?.sizes[0].costSingle2X + currentLogoPrice).toLocaleString(undefined, { maximumFractionDigits: 2 }));
  }, [currentLogoPrice]);

  const colorImageClick = async (item) => {
    if (!item) return;
    console.log("ITEM CLIKCED", item);
    setImgSrc(resolveImageUrl(item.frontModelImage));
    setImgSrcBack(resolveImageUrl(item.backModelImage));
    setCurrentItem(item);
    setCurrentColor(item.colorName);
    setCurrentSize(0);
    // await loadImages(item.sizes[0].productId);

    var decoCost = 0;
    for (var i = 0; i < selectedLogos.length; i++) {
      console.log("DECORATION", selectedLogos[i]);
      decoCost += selectedLogos[i].price;
    }



    setUpdatedLogos(new Date());
    //setCurrentPrice((item.sizes[0].costSingle2X + currentLogoPrice).toLocaleString(undefined, { maximumFractionDigits: 2 }));
    //updateLogosByPostion(item.logos);

  }

  const updateNewStatus = () => {

  }

  const closeImageModal = () => {
    setImageModalShow(false);
  }
  const removeProduct = async (event) => {
    console.log("REMOVE PRODUCT", productId);
    await CatalogService.removeFromCatalog(productId);
    navigate("/admin/catalog/0");
  }

  const colorImageOver = (item) => {
    setImgSrc(resolveImageUrl(item.frontModelImage));
    setCurrentColor(item.colorName);
    if (item.logos) {
      setLogoSrc(JSON.parse(item.logos)[0][0]);
    }
  }

  const colorImageExit = (item) => {
    setImgSrc(resolveImageUrl(currentItem.frontModelImage));
    setCurrentColor(currentItem.colorName);
    if (currentItem.logos) setLogoSrc(JSON.parse(currentItem.logos)[0][0]);
  }

  const sizeClick = (event) => {
    setCurrentSize(event.target.getAttribute("data"));
    setCurrentPrice(currentItem.sizes[event.target.getAttribute("data")].costSingle2X.toLocaleString(undefined, { maximumFractionDigits: 2 }));

  }

  const addToCartButtonClicked = () => {
    if (!loginStatus) return;

    if (!currentSize) {
      alert("Please select a size");
      return;
    }
    console.log("PROD ID", currentItem);
    let currentProduct = currentItem.sizes[currentSize].productId;
    dispatch(addToCart({ item: currentItem, quantity: qty, sizeIdx: currentSize }));
    console.log("PROD ID", currentProduct);
  }

  // Normalize shared catalog.currentItem: admin stores a color array, storefront stores { items: [] }.
  const adminCatalogItems = Array.isArray(catalogItem)
    ? catalogItem
    : (Array.isArray(catalogItem?.items) ? catalogItem.items : []);
  const primaryCatalogItem = adminCatalogItems[0] || null;

  useEffect(() => {
    console.log("IN USE EFFECT KEY CHANGED", productId);
    setLoading(true);
    setCurrentItem(null);
    dispatch(getAdminCatalogItem(productId));
  }, [location.key, descriptionChanged]);


  useEffect(() => {
    console.log("IN EFFECT", itemStatus);
    if (itemStatus === 'loading') {
      setLoading(true);
    } else
    if (itemStatus === 'idle') {
      dispatch(getAdminCatalogItem(productId));
      setCurrentPrice("Loading");
    } else
    if (itemStatus === 'failed') {
      setLoading(false);
      setCurrentItem(null);
    } else
    if (itemStatus === 'succeeded') {
      // adminItemStatus can already be 'succeeded' from a prior page (e.g. NHK)
      // while currentItem is still empty/stale until getAdminCatalogItem finishes.
      if (!primaryCatalogItem) {
        return;
      }

      const item = primaryCatalogItem;
      colorImageClick(item);

      if (item.markAsNew == null) {
        setMarkAsNew(true);
      } else if (!item.markAsNew) {
        setMarkAsNew(false);
      }

      // Set hidden state from catalog item
      setHidden(item.hidden ? true : false);

      // generate color arrays
      var newAvailableColors = [];
      var newSelectedColors = [];
      for (var i = 0; i < adminCatalogItems.length; i++) {
        newSelectedColors.push(JSON.parse(JSON.stringify(adminCatalogItems[i])));
      }
      setSelectedColors(newSelectedColors);

      for (var i = 0; i < otherProductItems.length; i++) {
        newAvailableColors.push(JSON.parse(JSON.stringify(otherProductItems[i])));
      }
      setAvailableColors(newAvailableColors);

      setCurrentItem(item);
      console.log("Decorations", decorations);
      console.log("CatalogItem", item);
      if (item.sizes?.[0]?.costSingle2X != null) {
        setCurrentPrice(item.sizes[0].costSingle2X.toLocaleString(undefined, { maximumFractionDigits: 2 }));
      }
      setCurrentSize(0);

      if (item.htmlDescription) {
        setEditedHtmlDescription(item.htmlDescription);
      } else {
        setEditedHtmlDescription(item.description || '');
      }

      setEditedTitle(item.title || '');
      setLoading(false);

      // Load capabilities for this product
      loadCapabilities();
    }
  }, [itemStatus, primaryCatalogItem, otherProductItems, decorations, dispatch]);

  // Load all capabilities and which ones are assigned to this product
  const loadCapabilities = async () => {
    try {
      const allCapabilities = await UserService.getProductCapabilities();
      setCapabilities(allCapabilities);

      const assignedCapabilities = await CatalogService.getProductCapabilities(productId);
      setProductCapabilities(assignedCapabilities);
    } catch (error) {
      console.error("Error loading capabilities:", error);
    }
  };

  // Load personalization fields for this style and subsite
  const loadPersonalizationFields = async () => {
    if (!currentStyle?.id || !currentSubsite?.id) return;
    try {
      const fields = await CatalogService.getPersonalizationFields(currentStyle.id, currentSubsite.id);
      const processedFields = fields.map(f => ({
        ...f,
        options: f.options ? JSON.parse(f.options) : [],
        colorMappings: f.colorMappings || []
      }));
      setPersonalizationFields(processedFields);
    } catch (error) {
      console.error("Error loading personalization fields:", error);
    }
  };

  // Load personalization fields when style and subsite are available
  useEffect(() => {
    if (currentStyle?.id && currentSubsite?.id) {
      loadPersonalizationFields();
    }
  }, [currentStyle?.id, currentSubsite?.id]);

  useEffect(() => {
    const loadDecoColors = async () => {
      try {
        const res = await LogoService.getLogoColors();
        setDecoColors(res?.data || []);
      } catch (error) {
        console.error("Error loading decoration colors:", error);
      }
    };
    loadDecoColors();
  }, []);

  // Personalization field management functions
  const addPersonalizationField = () => {
    setPersonalizationFields([
      ...personalizationFields,
      { name: '', fieldType: 'text', options: [], required: false, maxLength: 100, placeholder: '', price: '', decoColorId: '', colorMappings: [] }
    ]);
  };

  const updatePersonalizationField = (index, field, value) => {
    const updated = [...personalizationFields];
    updated[index][field] = value;
    setPersonalizationFields(updated);
  };

  const removePersonalizationField = async (index) => {
    const field = personalizationFields[index];
    if (field.id && currentSubsite?.id) {
      try {
        await CatalogService.deletePersonalizationField(field.id, currentSubsite.id);
      } catch (error) {
        console.error("Error deleting field:", error);
      }
    }
    setPersonalizationFields(personalizationFields.filter((_, i) => i !== index));
  };

  const addSelectOption = (fieldIndex) => {
    const updated = [...personalizationFields];
    updated[fieldIndex].options = [...(updated[fieldIndex].options || []), ''];
    setPersonalizationFields(updated);
  };

  const updateSelectOption = (fieldIndex, optionIndex, value) => {
    const updated = [...personalizationFields];
    updated[fieldIndex].options[optionIndex] = value;
    setPersonalizationFields(updated);
  };

  const updateColorMapping = (fieldIndex, colorId, decoColorId) => {
    const updated = [...personalizationFields];
    const maps = [...(updated[fieldIndex].colorMappings || [])];
    const idx = maps.findIndex(m => String(m.colorId) === String(colorId));
    if (!decoColorId) {
      if (idx >= 0) maps.splice(idx, 1);
    } else if (idx >= 0) {
      maps[idx] = { ...maps[idx], colorId, decoColorId };
    } else {
      maps.push({ colorId, decoColorId });
    }
    updated[fieldIndex].colorMappings = maps;
    setPersonalizationFields(updated);
  };

  const getMappedDecoColorId = (field, colorId) => {
    const map = (field.colorMappings || []).find(m => String(m.colorId) === String(colorId));
    return map?.decoColorId || '';
  };

  const removeSelectOption = (fieldIndex, optionIndex) => {
    const updated = [...personalizationFields];
    updated[fieldIndex].options = updated[fieldIndex].options.filter((_, i) => i !== optionIndex);
    setPersonalizationFields(updated);
  };

  const savePersonalizationFields = async () => {
    if (!currentStyle?.id) {
      alert("Product style not loaded.");
      return;
    }
    if (!currentSubsite?.id) {
      alert("No subsite selected.");
      return;
    }
    try {
      await CatalogService.savePersonalizationFields(currentStyle.id, personalizationFields, currentSubsite.id);
      alert("Personalization fields saved successfully for " + currentSubsite.subsiteName + "!");
    } catch (error) {
      console.error("Error saving personalization fields:", error);
      alert("Error saving personalization fields");
    }
  };

  // Handle capability checkbox change
  const handleCapabilityChange = async (capabilityId, checked) => {
    try {
      await CatalogService.limitProductToCapability(productId, capabilityId, checked);
      // Update local state
      if (checked) {
        setProductCapabilities([...productCapabilities, capabilityId]);
      } else {
        setProductCapabilities(productCapabilities.filter(id => id !== capabilityId));
      }
    } catch (error) {
      console.error("Error updating capability:", error);
    }
  };

  const updateAllDecorations = (decorations) => {
    setCurrentDecorations(decorations);

    // Select only the first decoration by default (single selection mode)
    if (decorations && decorations.length > 0) {
      console.log("Setting default single decoration:", decorations[0]);
      setSelectedLogos([decorations[0]]);
      setSelectedDecoration(decorations[0]);
    } else {
      setSelectedLogos([]);
      setSelectedDecoration(null);
    }
  }

  // Group decorations by setId
  const groupDecorationsBySetId = (decorations) => {
    if (!decorations) return [];

    const grouped = {};
    const ungrouped = [];

    decorations.forEach(decoration => {
      if (decoration.setId) {
        if (!grouped[decoration.setId]) {
          grouped[decoration.setId] = [];
        }
        grouped[decoration.setId].push(decoration);
      } else {
        ungrouped.push(decoration);
      }
    });

    // Convert grouped object to array of groups, plus individual decorations
    const result = [];

    // Add individual decorations (no setId)
    ungrouped.forEach(decoration => {
      result.push({ type: 'individual', decoration });
    });

    // Add grouped decorations
    Object.keys(grouped).forEach(setId => {
      result.push({ type: 'group', setId, decorations: grouped[setId] });
    });

    return result;
  };
  const updatePrice = (price) => {
    setCurrentLogoPrice(price);
  }

  const drop = (color) => {
    console.log("COLOR DROPPED");
    console.log(color.colorId);
    console.log(currentDragColor);

  };

  const addColorDrop = async (e) => {
    console.log("COLOR DROPPED IN COLOR DIV", currentDragColor);

    const color = await CatalogService.addColorToCatalogItem(currentDragColor.colorId, primaryCatalogItem?.id || currentItem?.id);

    // remove from available colors
    var removedItems = [];
    var newAvailableColors = JSON.parse(JSON.stringify(availableColors));

    for (var i = 0; i < newAvailableColors.length; i++) {
      console.log("OTHER PRODUCT ITEM", newAvailableColors[i], currentDragColor);
      if (newAvailableColors[i].colorName === currentDragColor.colorName) {
        removedItems = newAvailableColors.splice(i, 1);
        break;
      }
    }
    setAvailableColors(newAvailableColors);

    var newCatalogItem = JSON.parse(JSON.stringify(catalogItem));
    newCatalogItem.push(removedItems[0]);
    catalogItem = newCatalogItem;

    var newSelectedColors = JSON.parse(JSON.stringify(selectedColors));
    newSelectedColors.push(removedItems[0]);
    setSelectedColors(newSelectedColors);

    var newAvailableColors = JSON.parse(JSON.stringify(availableColors));
    for (var i = 0; i < newAvailableColors.length; i++) {
      if (newAvailableColors[i].colorName === currentDragColor.colorName) {
        newAvailableColors.splice(i, 1);
        break;
      }
    }
    setAvailableColors(newAvailableColors);

  };

  const handleAddSizesClick = () => {
    dispatch(addColor(currentDragColorSizes));
  };

  const removeColorDrop = async (e) => {
    console.log("COLOR DROPPED IN REMOVE COLOR DIV");
    console.log(currentDragColor);

    const color = await CatalogService.removeColorFromCatalogItem(currentDragColor.colorId, primaryCatalogItem?.id || currentItem?.id);

    var newCatalogItem = JSON.parse(JSON.stringify(catalogItem));
    // remove item from catalogItem
    for (var i = 0; i < newCatalogItem.length; i++) {
      if (newCatalogItem[i].colorName === currentDragColor.colorName) {
        newCatalogItem.splice(i, 1);
        break;
      }
    }

    catalogItem = newCatalogItem;
    var removedItems = null;

    var newSelectedColors = JSON.parse(JSON.stringify(selectedColors));
    // remove item from selectedColors
    for (var i = 0; i < newSelectedColors.length; i++) {
      if (newSelectedColors[i].colorName === currentDragColor.colorName) {
        removedItems = newSelectedColors.splice(i, 1);
        break;
      }
    }
    setSelectedColors(newSelectedColors);

    var newAvailableColors = JSON.parse(JSON.stringify(availableColors));
    newAvailableColors.push(removedItems[0]);
    setAvailableColors(newAvailableColors);

  };

  const allowDrop = (e) => {
    e.preventDefault();
  };

  const toggleLightLogo = async (item) => {
    console.log("TOGGLE LIGHT", item);
    var newLogos = await LogoService.toggleLight(item.subsiteDecorationId, currentItem.productId);

    //await loadImages(currentItem.productId);

  }

  const decoClicked = (logo) => {
    // Only allow one logo to be selected at a time
    console.log("Logo clicked:", logo);
    setSelectedLogos([logo]);
    setSelectedDecoration(logo);
  }


  const dragStarted = (color) => {
    console.log("DRAG STARTED", color);
    setCurrentDragColor(color);
  }

  const addLogo = async (logoSet, updateMode, kitOnly) => {

    var productId = currentItem.sizes[0].productId;

    var status = await LogoService.addLogo({ productId: productId, logoSet: logoSet, updateMode: updateMode, kitOnly: kitOnly });
    console.log("STATUS", status);
    if (status.status) {
      var newCurrentDecorations = [...currentDecorations];
      if(Array.isArray(status.data)) {
        for(var i=0; i<status.data.length; i++) {
          newCurrentDecorations.push(status.data[i]);
        }
      } else {
        newCurrentDecorations.push(status.data);
      }
      setCurrentDecorations(newCurrentDecorations);
    } else {

    }
    setUpdatedLogos(new Date());
    //loadImages(currentItem.sizes[0].productId);
  }

  const deleteLogo = async (logo) => {
    console.log("DELETE LOGO", logo);
    await LogoService.deleteLogo(logo.id);

    // remove from currentDecorations
    var newCurrentDecorations = [...currentDecorations];
    for (var i = 0; i < newCurrentDecorations.length; i++) {
      if (newCurrentDecorations[i].id === logo.id) {
        newCurrentDecorations.splice(i, 1);
        break;
      }
    }
    setCurrentDecorations(newCurrentDecorations);
    setSelectedDecoration(null);
    setUpdatedLogos(new Date());
  }

  const deleteLogoSet = async (setId) => {
    console.log("DELETE LOGO SET", setId);

    // Find all logos in the set
    const logosInSet = currentDecorations.filter(logo => logo.setId === setId);

    // Delete each logo in the set
    for (const logo of logosInSet) {
      await LogoService.deleteLogo(logo.id);
    }

    // Remove all logos in the set from currentDecorations
    var newCurrentDecorations = currentDecorations.filter(logo => logo.setId !== setId);
    setCurrentDecorations(newCurrentDecorations);
    setSelectedDecoration(null);
    setUpdatedLogos(new Date());
  }

  const closeLogoModalShow = () => {
    setAddLogoModalShow(false);
  }

  // Logo capability functions
  const openLogoCapabilityModal = async (logo) => {
    setSelectedLogoForCapability(logo);
    // Check if this logo already has capabilities
    const existingCapabilities = decorationCapabilities[logo.decoration_logo.id] || [];
    setLogoCapabilityIds(existingCapabilities);
    setShowLogoCapabilityModal(true);
  };

  const saveLogoCapability = async () => {
    if (selectedLogoForCapability) {
      await UserService.setLogoCapability(selectedLogoForCapability.decoration_logo.id, logoCapabilityIds);
      // Update local state
      setDecorationCapabilities(prev => ({
        ...prev,
        [selectedLogoForCapability.decoration_logo.id]: logoCapabilityIds
      }));
    }
    setShowLogoCapabilityModal(false);
    setSelectedLogoForCapability(null);
  };

  const toggleLogoCapability = (capId) => {
    setLogoCapabilityIds(prev => {
      if (prev.includes(capId)) {
        return prev.filter(id => id !== capId);
      } else {
        return [...prev, capId];
      }
    });
  };

  // Color capability functions
  const openColorCapabilityModal = async (color) => {
    setSelectedColorForCapability(color);
    // Check if this color already has capabilities
    const existingCapabilities = colorCapabilities[color.colorId] || [];
    setColorCapabilityIds(existingCapabilities);
    setShowColorCapabilityModal(true);
  };

  const saveColorCapability = async () => {
    if (selectedColorForCapability) {
      await UserService.setColorCapability(selectedColorForCapability.colorId, colorCapabilityIds);
      // Update local state
      setColorCapabilities(prev => ({
        ...prev,
        [selectedColorForCapability.colorId]: colorCapabilityIds
      }));
    }
    setShowColorCapabilityModal(false);
    setSelectedColorForCapability(null);
  };

  const toggleColorCapability = (capId) => {
    setColorCapabilityIds(prev => {
      if (prev.includes(capId)) {
        return prev.filter(id => id !== capId);
      } else {
        return [...prev, capId];
      }
    });
  };

  // Load capability restrictions when decorations/colors change
  useEffect(() => {
    const loadCapabilityRestrictions = async () => {
      if (!superAdmin) return;
      try {
        const restrictions = await UserService.getCapabilityRestrictions();
        // Build maps of decorationLogoId -> [capabilityIds] and colorId -> [capabilityIds]
        const logoMap = {};
        const colorMap = {};
        restrictions.logos?.forEach(l => {
          if (!logoMap[l.decorationLogoId]) logoMap[l.decorationLogoId] = [];
          logoMap[l.decorationLogoId].push(l.capabilityId);
        });
        restrictions.colors?.forEach(c => {
          if (!colorMap[c.colorId]) colorMap[c.colorId] = [];
          colorMap[c.colorId].push(c.capabilityId);
        });
        setDecorationCapabilities(logoMap);
        setColorCapabilities(colorMap);
      } catch (error) {
        console.error("Error loading capability restrictions:", error);
      }
    };
    loadCapabilityRestrictions();
  }, [superAdmin]);

  const handleDescriptionModalSave = async () => {
    console.log("SAVE DESCRIPTION", currentItem);
    var content = await CatalogService.updateDescription(currentItem.productId, editedHtmlDescription);
    setShowDescription(false);
    setDescriptionChanged(!descriptionChanged);
  }

  const handleTitleModalSave = async () => {
    console.log("SAVE TITLE", currentItem);
    await CatalogService.updateTitle(currentItem.productId, editedTitle);
    setShowTitle(false);
    setDescriptionChanged(!descriptionChanged); // Trigger reload
  }

  const updateModeChanged = (mode) => {
    console.log("UPDATE MODE", mode);
    setUpdateMode(mode);
  }

  const setNewDisplayedDecorations = (decos) => {
    console.log("UPDATE NEW DECOS", decos);
    setDisplayedDecorations(decos);
  }

  const setAsFeatured = async () => {
    console.log("SET AS FEATURED", currentItem);
    var status = await AdminService.addFeatured(currentItem.productId);
    if (status && status.error) {
      setAddFeaturedError(true);
      setAddFeaturedMessage(status.message);
    } else {
      setAddFeaturedError(false);
      setAddFeaturedMessage("Set as Featured");
    }
  }

  // Group decorations by location, optionally restricted to non-set (individual) decorations only
  const groupDecorationsByLocationForNHK = (decorations, individualOnly = false) => {
    if (!decorations || decorations.length === 0) return [];

    const locationMap = {};

    decorations.forEach(decoration => {
      if (individualOnly && decoration.setId) return;
      const locationId = decoration.deco_location?.id || decoration.decoLocationId;
      const locationName = decoration.deco_location?.description || 'Unknown Location';

      if (!locationMap[locationId]) {
        locationMap[locationId] = {
          locationId: locationId,
          locationName: locationName,
          decorations: []
        };
      }
      locationMap[locationId].decorations.push(decoration);
    });

    return Object.values(locationMap);
  };

  // Group decorations into logo sets keyed by setId
  const groupDecorationsBySet = (decorations) => {
    if (!decorations || decorations.length === 0) return [];
    const setMap = {};
    decorations.forEach(decoration => {
      if (!decoration.setId) return;
      if (!setMap[decoration.setId]) {
        setMap[decoration.setId] = { setId: decoration.setId, decorations: [] };
      }
      setMap[decoration.setId].decorations.push(decoration);
    });
    return Object.values(setMap);
  };

  // Helper function to get decorations for adding to NHK
  const getDecorationsForNHK = () => {
    if (!currentDecorations || currentDecorations.length === 0) {
      return [];
    }
    // Auto-pick from individual (non-set) decorations only
    const grouped = groupDecorationsByLocationForNHK(currentDecorations, true);
    return grouped.map(group => group.decorations[0]);
  };

  // Open kit selection modal
  const openKitSelectModal = async () => {
    setLoadingKits(true);
    setShowKitSelectModal(true);
    try {
      const kits = await CatalogService.getAllNewHireKits();
      setAvailableKits(kits);
    } catch (err) {
      console.error("Error loading kits:", err);
    }
    setLoadingKits(false);
  };

  // Get kit name by ID
  const getKitName = (kitId) => {
    const kit = availableKits.find(k => k.id === kitId);
    return kit ? kit.title : "New Hire Kit";
  };

  // Proceed with adding item (after duplicate check passed or user chose to create new)
  const proceedWithAddToNHK = async (kitId, decorationsToUse) => {
    if (!currentDecorations || currentDecorations.length === 0) {
      await CatalogService.addNewHireKitItem(currentItem.productId, [], kitId);
      setNewHireKitMessage(`Added to ${getKitName(kitId)}`);
      return;
    }

    const grouped = groupDecorationsByLocationForNHK(currentDecorations, true);
    const sets = groupDecorationsBySet(currentDecorations);
    const hasMultipleAtAnyLocation = grouped.some(group => group.decorations.length > 1);
    const hasSets = sets.length > 0;

    if ((hasMultipleAtAnyLocation || hasSets) && decorationsToUse.length === 0) {
      // Show modal to let user select decorations
      setDecorationsByLocation(grouped);
      setAvailableLogoSets(sets);
      setPendingNewHireKitId(kitId);
      setShowDecorationModal(true);
    } else {
      const selectedDecorations = decorationsToUse.length > 0 ? decorationsToUse : getDecorationsForNHK();
      await CatalogService.addNewHireKitItem(currentItem.productId, selectedDecorations, kitId);
      setNewHireKitMessage(`Added to ${getKitName(kitId)}`);
    }
  };

  const addToNewHireKit = async (kitId) => {
    console.log("ADD TO NEW HIRE KIT", currentItem, currentDecorations, kitId);
    setNewHireKitMessage("");
    setShowKitSelectModal(false);

    // Check if this style already exists in the NHK
    const existingCheck = await CatalogService.checkExistingNHKItem(currentStyle.id, kitId);
    console.log("Existing NHK check:", existingCheck);

    if (existingCheck.exists) {
      // Style already exists - show modal to ask user what to do
      setExistingNHKItems(existingCheck.items);
      setPendingNewHireKitId(kitId);
      setPendingNHKDecorations(getDecorationsForNHK());
      setShowDuplicateModal(true);
      return;
    }

    // No existing items, proceed normally
    await proceedWithAddToNHK(kitId, []);
  }

  const handleDuplicateModalCreateNew = async () => {
    // User chose to create a new entry
    setShowDuplicateModal(false);
    await proceedWithAddToNHK(pendingNewHireKitId, pendingNHKDecorations);
    setPendingNewHireKitId(null);
    setExistingNHKItems([]);
    setPendingNHKDecorations([]);
  };

  const handleDuplicateModalAddColor = async () => {
    // User chose to add color to existing entry
    setShowDuplicateModal(false);
    // Use the first existing item's decorations
    const existingNhkiId = existingNHKItems[0].id;
    await CatalogService.addColorToNHKItem(existingNhkiId, currentItem.productId, pendingNewHireKitId);
    setNewHireKitMessage(`Added color to ${getKitName(pendingNewHireKitId)}`);
    setPendingNewHireKitId(null);
    setExistingNHKItems([]);
    setPendingNHKDecorations([]);
  };

  const handleDuplicateModalClose = () => {
    setShowDuplicateModal(false);
    setPendingNewHireKitId(null);
    setExistingNHKItems([]);
    setPendingNHKDecorations([]);
  };

  const handleDecorationModalConfirm = async (selectedDecorations) => {
    console.log("Modal confirmed with decorations:", selectedDecorations);
    await CatalogService.addNewHireKitItem(currentItem.productId, selectedDecorations, pendingNewHireKitId);
    setShowDecorationModal(false);
    setNewHireKitMessage(`Added to ${getKitName(pendingNewHireKitId)}`);
    setPendingNewHireKitId(null);
    setDecorationsByLocation([]);
    setAvailableLogoSets([]);
  }

  const handleDecorationModalClose = () => {
    setShowDecorationModal(false);
    setPendingNewHireKitId(null);
    setDecorationsByLocation([]);
    setAvailableLogoSets([]);
  }

  const cloneProduct = async (subsites) => {
    console.log("CLONE PRODUCT", currentItem, subsites);
    var newProduct = await CatalogService.cloneProduct(currentItem.productId, subsites);
    //navigate("/admin/product/" + newProduct.productId);
  }

  const closeProductCloneModal = () => {
    //ModalShow(false);
  }

  const updateIgniteCategoryForStyle = async (categoryId, checked) => {
    const status = await CategoryService.updateIgniteCategoryForStyle(categoryId, checked, currentStyle.id);
  }

  const updatePrices = async () => {
    console.log("UPDATE PRICES");
    setPriceUpdateSpinner(true);
    const source = (currentStyle?.source || '').toLowerCase();
    if (source === 'sands') {
      await AdminService.refreshSandsProducts(currentItem.productId);
    } else {
      await AdminService.updatePrices(currentItem.productId);
    }
    setPriceUpdateSpinner(false);
    dispatch(getAdminCatalogItem(productId));
  }

  const updateColors = async () => {
    console.log("UPDATE COLORS");
    setColorUpdateSpinner(true);
    const source = (currentStyle?.source || '').toLowerCase();
    if (source === 'sands') {
      await AdminService.refreshSandsProducts(currentItem.productId);
    } else {
      await AdminService.updateSanmarColors(currentItem.productId);
    }
    setColorUpdateSpinner(false);
    dispatch(getAdminCatalogItem(productId));
  }

  const loadInventory = async () => {
    setInventoryLoading(true);
    setInventoryMessage(null);
    try {
      const result = await AdminService.refreshSandsInventory(currentItem.productId);
      const r = result && result.data ? result.data : {};
      setInventoryMessage(`Loaded ${r.rowsInserted || 0} warehouse rows for ${r.skuCount || 0} SKUs.`);
    } catch (error) {
      const msg = error && error.response && error.response.data && error.response.data.error
        ? error.response.data.error
        : (error.message || 'Failed to load inventory');
      setInventoryMessage(`Error: ${msg}`);
    } finally {
      setInventoryLoading(false);
    }
  }

  const openSizeOverrideModal = (size) => {
    setEditingSize(size);
    setEditingSizeOverride(size.sizeNameOverride || '');
    setSizeOverrideModalShow(true);
  };

  const closeSizeOverrideModal = () => {
    setSizeOverrideModalShow(false);
    setEditingSize(null);
    setEditingSizeOverride('');
  };

  const saveSizeOverride = async () => {
    if (!editingSize) return;
    setSizeOverrideSaving(true);
    try {
      await AdminService.updateSizeNameOverride(editingSize.sizeId, editingSizeOverride || '');
      setDescriptionChanged((prev) => !prev);
      closeSizeOverrideModal();
    } catch (error) {
      console.error("Error saving size override:", error);
      alert("Failed to save size override");
    } finally {
      setSizeOverrideSaving(false);
    }
  };

  const formatPantsSize = (sizeName) => {
    var isFour = /^\d{4}$/.test(sizeName);
    if (isFour) {
      return sizeName.substring(0, 2) + "x" + sizeName.substring(2);
    } else {
      return sizeName;
    }
  }

  let content = "";
  let price = 0;

  return (
    <div>
      {(!currentItem || loading) && <Spinner />}
      {(currentItem && !loading) && (
        <div className="container">
          <ProductMenu url="/admin/catalog/" menuBgColor={currentSubsite.subsite_content?.menuBgColor} menuTextHoverColor={currentSubsite.subsite_content?.menuTextHoverColor} menuTextColor={currentSubsite.subsite_content?.menuTextColor} />
          <div class="product-details-container">
            <div class="product-img-lg">
              <AdminImageGallery
                productId={currentItem.productId}
                displayDecorations={selectedLogos}
                selectedDecoration={selectedDecoration}
                showAdminControls={true}
                forceUpdate={updatedLogos}
                updateAllDecorations={updateAllDecorations}
                updatePrice={updatePrice}
                updateDisplayedDecorations={setNewDisplayedDecorations} />
            </div>
            <div class="product-content">
              <div><hr /></div>
              <div style={{ margin: 0, padding: 0 }}>
                <span style={{ fontWeight: "bold", color: "#999999" }}>TITLE: </span>
                <LogoButton style={{ color: "blue" }} size="25" Icon={Pencil} tooltip="Edit Title" onClick={() => setShowTitle(true)} />
              </div>
              <div class="title">{currentItem.title}</div>
              <div><hr /></div>
              {currentItem.updatedAt && (
                new Date(currentItem.updatedAt).getTime() + ((24 * 60 * 60 * 1000) * (currentSubsite.newDayLimit ? currentSubsite.newDayLimit : 60)) > new Date().getTime() && markAsNew ? (
                  <Container>
                    <Row>
                      <Col className="new-product">
                          New Item
                      </Col>
                      <Col className="new-product" md="auto">
                        <Form.Check
                          style={{ display: "inline-block" }}
                          type="switch"
                          id="custom-switch"
                          label="Mark Not New"
                          checked={markAsNew}
                          onChange={(event) => { console.log("SETTING NOT NEW"); markAsNewChanged(event.target.checked); }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div style={{ flex: 1 }}>
                          The New Item banner will be shown for {Math.floor(currentSubsite.newDayLimit - ((new Date().getTime() - new Date(currentItem.updatedAt).getTime()) / ((24 * 60 * 60 * 1000))))} more days <br />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div><hr /></div>
                      </Col>
                    </Row>
                  </Container>
                ) : (
                  <Container>
                    <Row className="not-new-product">
                      <Col>
                          New Item
                      </Col>
                      <Col md="auto">
                        <Form.Check
                          style={{ display: "inline-block" }}
                          type="switch"
                          id="custom-switch"
                          label="Mark New"
                          checked={markAsNew}
                          onChange={(event) => { console.log("SETTING NOT NEW"); markAsNewChanged(event.target.checked); }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div style={{ flex: 1 }}>
                          The New Item banner will not be shown.<br />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div><hr /></div>
                      </Col>
                    </Row>
                  </Container>
                )
              )}
              <div style={{ margin: 0, padding: 0 }}><span style={{ fontWeight: "bold", color: "#999999" }}>DESCRIPTION: <LogoButton style={{ color: "blue" }} size="25" Icon={Pencil} tooltip="Edit Description" onClick={() => setShowDescription(true)} /></span></div>
              <div class="description" dangerouslySetInnerHTML={{ __html: currentItem.htmlDescription ? currentItem.htmlDescription : currentItem.description }} />
              <div><hr /></div>
              {currentStyle?.productType && (
                <>
                  <div style={{ margin: 0, padding: 0 }}>
                    <span style={{ fontWeight: "bold", color: "#999999" }}>PRODUCT TYPE: </span>
                    <span style={{ fontWeight: "500", color: currentStyle.productType === 'Accessory' ? '#17a2b8' : '#6f42c1' }}>
                      {currentStyle.productType}
                    </span>
                  </div>
                  <div><hr /></div>
                </>
              )}
              {loginStatus ? (
                <>
                  <div style={{ margin: 0, padding: 0 }}><span style={{ fontWeight: "bold", color: "#999999" }}>PRICE:</span> <LogoButton style={{ color: "blue" }} size="25" Icon={ArrowClockwise} tooltip={(currentStyle?.source || '').toLowerCase() === 'sands' ? "Update Price from S&S" : "Update Price from Sanmar"} onClick={updatePrices} disabled={priceUpdateSpinner} />
                    {priceUpdateSpinner && <Spinner size="sm" animation="border" />}</div>
                  {(currentStyle?.source || '').toLowerCase() === 'sands' && (
                    <div style={{ margin: '4px 0' }}>
                      <Button size="sm" onClick={loadInventory} disabled={inventoryLoading}>
                        {inventoryLoading && <Spinner size="sm" animation="border" />} Load Inventory
                      </Button>
                      {inventoryMessage && <div style={{ marginTop: 4, fontSize: '0.9em' }}>{inventoryMessage}</div>}
                    </div>
                  )}

                  {/* Flat pricing (default) */}
                  {(!currentItem?.pricingType || currentItem?.pricingType === PRICING_TYPES.FLAT) && (
                    <>
                      {currentItem?.sizes[0] && currentItem?.sizes[0]?.costSingle2X && (
                        <div class="price">${(currentItem?.sizes[0]?.costSingle2X + currentLogoPrice).toLocaleString(undefined, { maximumFractionDigits: 2 })} ({currentItem?.sizes[0]?.costSingle2X.toLocaleString(undefined, { maximumFractionDigits: 2 })} + {currentLogoPrice}) </div>
                      )}
                      {!currentItem?.sizes[0] || !currentItem?.sizes[0]?.costSingle2X && (
                        <div class="price">Price Not Set</div>
                      )}
                    </>
                  )}

                  {/* Quantity pricing */}
                  {currentItem?.pricingType === PRICING_TYPES.QUANTITY && (
                    <div className="quantity-pricing" style={{ marginBottom: 10 }}>
                      <div style={{ fontWeight: 'bold', marginBottom: 5 }}>Quantity Pricing:</div>
                      {quantityPrices && quantityPrices.length > 0 ? (
                        quantityPrices.map((tier, index) => (
                          <div key={index} style={{ fontSize: '0.9em' }}>
                            {tier.quantity}: ${parseFloat(tier.price).toFixed(2)} each
                          </div>
                        ))
                      ) : (
                        <div style={{ color: '#999', fontStyle: 'italic' }}>No quantity tiers defined</div>
                      )}
                    </div>
                  )}

                  {/* Bill later pricing */}
                  {currentItem?.pricingType === PRICING_TYPES.BILL_LATER && (
                    <div className="price" style={{ color: '#666', fontStyle: 'italic' }}>
                      Price: Billed Later
                    </div>
                  )}
                </>
              ) : null

              }
              <div><hr /></div>

              <CategoryList style={currentStyle} editEnabled={true} updateIgniteCategoryForStyle={updateIgniteCategoryForStyle} isSuperAdmin={superAdmin} />
              <div><hr /></div>

              <div className="color-title">
                <span style={{ fontWeight: "bold", color: "#999999" }}>DECORATIONS:</span> <LogoButton style={{ color: "green" }} size="25" Icon={PlusCircle} tooltip="Add Decoration" onClick={() => setAddLogoModalShow(true)} />
              </div>
              <div style={{ padding: 5 }}>
                {currentDecorations && groupDecorationsBySetId(currentDecorations).map((item, index) => {
                  if (item.type === 'individual') {
                    const logo = item.decoration;
                    console.log("INDIVIDUAL LOGO", logo);
                    console.log("Selected Logo", selectedDecoration);
                    const capList = decorationCapabilities[logo.decoration_logo?.id] || [];
                    const hasCapability = capList.length > 0;
                    return (
                      <div key={`individual-${logo.id}`} style={{ display: "flex", padding: 5, flexDirection: "row", flexWrap: "wrap", borderStyle: "solid", borderWidth: 1, borderColor: logo.id === selectedDecoration?.id ? "#0000FF" : "#CCCCCC" }}>
                        <div style={{ flex: 1 }}><img src={apiUrl + logo.decoration_logo.imageUrl} height={50} style={{ padding: 5, backgroundColor: "#CCCCCC" }} onClick={() => decoClicked(logo)} /></div>
                        <div style={{ flex: 1, marginLeft: 5, fontSize: 12 }}>
                          {logo.decoration_logo.decorationName}<br />{logo.deco_location.description}<br />{logo.decoration_logo.decoType}
                          {hasCapability && <span style={{ color: "#007bff", fontSize: 10 }}><br /><ShieldLock size={10} /> {capList.length} cap{capList.length > 1 ? 's' : ''}</span>}
                          {logo.kitOnly && <><br /><span style={{ display: "inline-block", backgroundColor: "#fd7e14", color: "white", fontSize: 10, fontWeight: "bold", padding: "2px 6px", borderRadius: 3, marginTop: 2 }}>NEW HIRE KIT ONLY</span></>}
                        </div>
                        {superAdmin && (
                          <LogoButton style={{ color: hasCapability ? "#007bff" : "#999" }} size="20" Icon={ShieldLock} tooltip="Set Capability Restriction" onClick={() => openLogoCapabilityModal(logo)} />
                        )}
                        <LogoButton style={{ color: "red" }} size="25" Icon={XCircle} tooltip="Remove Decoration" onClick={() => deleteLogo(logo)} />
                      </div>
                    );
                  } else if (item.type === 'group') {
                    console.log("LOGO GROUP", item);
                    const isGroupSelected = item.decorations.some(logo => logo.id === selectedDecoration?.id);
                    const isGroupKitOnly = item.decorations.length > 0 && item.decorations.every(logo => logo.kitOnly);
                    return (
                      <div key={`group-${item.setId}`} style={{ marginBottom: 10, borderStyle: "solid", borderWidth: 2, borderColor: isGroupSelected ? "#0000FF" : "#999999", borderRadius: 5, padding: 5 }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 12, fontWeight: "bold", color: "#666666", marginBottom: 5 }}>
                          <span>
                            Logo Set ({item.decorations.length} logos)
                            {isGroupKitOnly && <span style={{ display: "inline-block", backgroundColor: "#fd7e14", color: "white", fontSize: 10, fontWeight: "bold", padding: "2px 6px", borderRadius: 3, marginLeft: 8 }}>NEW HIRE KIT ONLY</span>}
                          </span>
                          <LogoButton style={{ color: "red" }} size="20" Icon={XCircle} tooltip="Remove Entire Logo Set" onClick={() => deleteLogoSet(item.setId)} />
                        </div>
                        {item.decorations.map(logo => {
                          const capList = decorationCapabilities[logo.decoration_logo?.id] || [];
                          const hasCapability = capList.length > 0;
                          return (
                            <div key={`group-logo-${logo.id}`} style={{ display: "flex", padding: 3, flexDirection: "row", flexWrap: "wrap", borderStyle: "solid", borderWidth: 1, borderColor: logo.id === selectedDecoration?.id ? "#0000FF" : "#DDDDDD", marginBottom: 3 }}>
                              <div style={{ flex: 1 }}><img src={apiUrl + logo.decoration_logo.imageUrl} height={40} style={{ padding: 3, backgroundColor: "#CCCCCC" }} onClick={() => decoClicked(logo)} /></div>
                              <div style={{ flex: 1, marginLeft: 5, fontSize: 11 }}>
                                {logo.decoration_logo.decorationName}<br />{logo.deco_location.description}<br />{logo.decoration_logo.decoType}
                                {hasCapability && <span style={{ color: "#007bff", fontSize: 10 }}><br /><ShieldLock size={10} /> {capList.length} cap{capList.length > 1 ? 's' : ''}</span>}
                                {!isGroupKitOnly && logo.kitOnly && <><br /><span style={{ display: "inline-block", backgroundColor: "#fd7e14", color: "white", fontSize: 9, fontWeight: "bold", padding: "1px 5px", borderRadius: 3, marginTop: 2 }}>NEW HIRE KIT ONLY</span></>}
                              </div>
                              {superAdmin && (
                                <LogoButton style={{ color: hasCapability ? "#007bff" : "#999" }} size="18" Icon={ShieldLock} tooltip="Set Capability Restriction" onClick={() => openLogoCapabilityModal(logo)} />
                              )}
                            </div>
                          );
                        })}
                      </div>
                    );
                  }
                  return null;
                })
                }
              </div>
              <div><hr /></div>
              <span style={{ fontWeight: "bold", color: "#999999" }}>ACTIONS:</span>
              <ul>
                <li>Set As Featured <LogoButton style={{ color: "blue" }} size="25" Icon={Asterisk} tooltip="Set as Featured" onClick={setAsFeatured} />
                  {addFeaturedMessage && (
                    <><br /><div style={{ color: addFeaturedError ? "#cc0000" : "#009900" }}>
                      {!addFeaturedError && <Check size="20"></Check>}
                      {addFeaturedMessage}
                    </div></>
                  )}
                </li>
                <li>Add to New Hire Kit <LogoButton style={{ color: "Green" }} size="25" Icon={PlusCircle} tooltip="Add to New Hire Kit" onClick={openKitSelectModal} />
                </li>
                {newHireKitMessage && (
                  <li><div style={{ color: "#009900", marginTop: 5 }}><Check size="20"></Check>{newHireKitMessage}</div></li>
                )}
              </ul>
              <div><hr /></div>
              <Accordion flush style={{ marginBottom: 10 }}>
                <Accordion.Item eventKey="limit-capability">
                  <Accordion.Header>
                    <span style={{ fontWeight: "bold", color: "#999999", fontSize: 14 }}>
                      LIMIT TO CAPABILITY
                      {productCapabilities.length > 0 && (
                        <Badge bg="primary" style={{ marginLeft: 8, fontWeight: "normal" }}>
                          {productCapabilities.length}
                        </Badge>
                      )}
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ paddingTop: 8, paddingBottom: 8 }}>
                    <small style={{ color: "#666", display: "block", marginBottom: 10 }}>
                      Only users with selected capabilities can see this product. Leave all unchecked for no restriction.
                    </small>
                    {capabilities.length === 0 ? (
                      <div style={{ color: "#999" }}>No capabilities defined</div>
                    ) : (
                      <Form.Group>
                        {capabilities.map(capability => (
                          <Form.Check
                            key={capability.id}
                            type="checkbox"
                            id={`cap-${capability.id}`}
                            label={capability.capabilityTitle || capability.capabilityName}
                            checked={productCapabilities.includes(capability.id)}
                            onChange={(e) => handleCapabilityChange(capability.id, e.target.checked)}
                          />
                        ))}
                      </Form.Group>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <div><hr /></div>

              {/* Personalization Fields Section */}
              <div style={{ marginBottom: 15 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                  <span style={{ fontWeight: "bold", color: "#999999" }}>
                    PERSONALIZATION FIELDS
                    {currentSubsite && (
                      <Badge bg="secondary" style={{ marginLeft: 8, fontWeight: 'normal' }}>
                        {currentSubsite.subsiteName}
                      </Badge>
                    )}
                    {personalizationFields.length > 0 && (
                      <Badge bg="info" style={{ marginLeft: 8 }}>{personalizationFields.length}</Badge>
                    )}
                  </span>
                  <Button variant="outline-primary" size="sm" onClick={addPersonalizationField}>
                    <PlusCircle style={{ marginRight: 5 }} /> Add Field
                  </Button>
                </div>
                <small style={{ color: '#666', display: 'block', marginBottom: 10 }}>
                  Add text fields or dropdowns for <strong>{currentSubsite?.subsiteName || 'this subsite'}</strong>. Each subsite can have different personalization fields.
                </small>

                {personalizationFields.map((field, fieldIndex) => (
                  <Card key={fieldIndex} style={{ marginBottom: 10, padding: 10 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <div style={{ flex: 1 }}>
                        <Row className="mb-2">
                          <Col xs={6}>
                            <Form.Label>Field Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="e.g., Employee Name"
                              value={field.name}
                              onChange={(e) => updatePersonalizationField(fieldIndex, 'name', e.target.value)}
                            />
                          </Col>
                          <Col xs={4}>
                            <Form.Label>Field Type</Form.Label>
                            <Form.Select
                              value={field.fieldType}
                              onChange={(e) => updatePersonalizationField(fieldIndex, 'fieldType', e.target.value)}
                            >
                              <option value="text">Text</option>
                              <option value="select">Dropdown</option>
                            </Form.Select>
                          </Col>
                          <Col xs={2}>
                            <Form.Label>Required</Form.Label>
                            <Form.Check
                              type="checkbox"
                              checked={field.required}
                              onChange={(e) => updatePersonalizationField(fieldIndex, 'required', e.target.checked)}
                            />
                          </Col>
                        </Row>

                        {field.fieldType === 'text' && (
                          <Row className="mb-2">
                            <Col xs={6}>
                              <Form.Label>Placeholder</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Placeholder text"
                                value={field.placeholder || ''}
                                onChange={(e) => updatePersonalizationField(fieldIndex, 'placeholder', e.target.value)}
                              />
                            </Col>
                            <Col xs={4}>
                              <Form.Label>Max Length</Form.Label>
                              <Form.Control
                                type="number"
                                value={field.maxLength || ''}
                                onChange={(e) => updatePersonalizationField(fieldIndex, 'maxLength', parseInt(e.target.value) || null)}
                              />
                            </Col>
                          </Row>
                        )}

                        {field.fieldType === 'select' && (
                          <div style={{ marginTop: 10 }}>
                            <Form.Label>Dropdown Options</Form.Label>
                            {(field.options || []).map((option, optionIndex) => (
                              <div key={optionIndex} style={{ display: 'flex', marginBottom: 5 }}>
                                <Form.Control
                                  type="text"
                                  placeholder={`Option ${optionIndex + 1}`}
                                  value={option}
                                  onChange={(e) => updateSelectOption(fieldIndex, optionIndex, e.target.value)}
                                  style={{ marginRight: 5 }}
                                />
                                <Button variant="outline-danger" size="sm" onClick={() => removeSelectOption(fieldIndex, optionIndex)}>
                                  <XCircle />
                                </Button>
                              </div>
                            ))}
                            <Button variant="outline-secondary" size="sm" onClick={() => addSelectOption(fieldIndex)}>
                              <PlusCircle /> Add Option
                            </Button>
                          </div>
                        )}
                        <Row className="mt-2">
                          <Col xs={4}>
                            <Form.Label>Price (optional)</Form.Label>
                            <Form.Control
                              type="number"
                              min="0"
                              step="0.01"
                              placeholder="0.00"
                              value={field.price ?? ''}
                              onChange={(e) => updatePersonalizationField(fieldIndex, 'price', e.target.value === '' ? '' : e.target.value)}
                            />
                          </Col>
                        </Row>
                        <div className="mt-2">
                          <Form.Label>Decoration Color by Product Color</Form.Label>
                          {(!selectedColors || selectedColors.length === 0) ? (
                            <div style={{ color: '#666', fontSize: '0.9em' }}>
                              Add product colors below, then set a decoration color for each.
                            </div>
                          ) : (
                            selectedColors.map((productColor) => (
                              <Row key={productColor.colorId} className="mb-1 align-items-center">
                                <Col xs={4} style={{ fontSize: '0.9em' }}>
                                  {productColor.colorName || `Color #${productColor.colorId}`}
                                </Col>
                                <Col xs={8}>
                                  <Form.Select
                                    size="sm"
                                    value={getMappedDecoColorId(field, productColor.colorId)}
                                    onChange={(e) => updateColorMapping(
                                      fieldIndex,
                                      productColor.colorId,
                                      e.target.value === '' ? '' : parseInt(e.target.value, 10)
                                    )}
                                  >
                                    <option value="">— None —</option>
                                    {decoColors.map((c) => (
                                      <option key={c.id} value={c.id}>
                                        {c.colorName}{c.thread ? ` (thread ${c.thread})` : ''}{c.pms ? ` · PMS ${c.pms}` : ''}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </Col>
                              </Row>
                            ))
                          )}
                        </div>
                      </div>
                      <Button variant="outline-danger" size="sm" onClick={() => removePersonalizationField(fieldIndex)} style={{ marginLeft: 10 }}>
                        <XCircle />
                      </Button>
                    </div>
                  </Card>
                ))}

                {personalizationFields.length > 0 && (
                  <Button variant="success" size="sm" onClick={savePersonalizationFields} style={{ marginTop: 10 }}>
                    Save Personalization Fields
                  </Button>
                )}
              </div>
              <div><hr /></div>

              <div class="color-title">
                <span style={{ fontWeight: "bold", color: "#999999" }}>Color:</span> {currentColor ? currentColor : currentItem.colorName}
              </div>
              <div class="color-title">
                Selected Colors: {superAdmin && <small style={{ color: "#666" }}>(Click shield to restrict)</small>}
              </div>
              <div class="colors" onDrop={addColorDrop} onDragOver={allowDrop}>
                {selectedColors && selectedColors.map(item => {
                  const capList = colorCapabilities[item.colorId] || [];
                  const hasCapability = capList.length > 0;
                  return (
                    <div key={item.colorId} class="color-swatch" style={{ position: "relative" }}>
                      {item.squareImageName && (
                        <img src={resolveSwatchUrl(item.squareImageName)} height={50}
                          onClick={() => colorImageClick(item)}
                          onDragEnd={() => drop(item)}
                          onDragStart={() => dragStarted(item)}
                          draggable
                        />)}
                      {item.hexColor && !item.squareImageName && (
                        <div style={{ backgroundColor: `${item.hexColor}`, width: 75, height: 75 }} onClick={() => colorImageClick(item)}></div>
                      )}
                      {superAdmin && (
                        <div style={{ position: "absolute", top: 0, right: 0, cursor: "pointer" }} onClick={() => openColorCapabilityModal(item)}>
                          <ShieldLock size={16} color={hasCapability ? "#007bff" : "#ccc"} />
                        </div>
                      )}
                      {hasCapability && (
                        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, backgroundColor: "rgba(0,123,255,0.7)", color: "white", fontSize: 8, textAlign: "center" }}>{capList.length} cap{capList.length > 1 ? 's' : ''}</div>
                      )}
                    </div>
                  );
                })}
              </div>
              <div class="color-title">
                Available Colors: <LogoButton style={{ color: "blue" }} size="25" Icon={ArrowClockwise} tooltip={(currentStyle?.source || '').toLowerCase() === 'sands' ? "Update Colors from S&S" : "Update Colors from Sanmar"} onClick={updateColors} disabled={colorUpdateSpinner} />
                {colorUpdateSpinner && <Spinner size="sm" animation="border" />}
              </div>
              <div class="colors" onDrop={removeColorDrop} onDragOver={allowDrop}>
                {availableColors && availableColors.map(item => (
                  <div class="color-swatch" style={{ position: "relative" }}>
                    <img src={resolveSwatchUrl(item.squareImageName)} height={50}
                      onClick={(event) => colorImageClick(item)}
                      onDragEnd={() => drop(item)}
                      onDragStart={() => dragStarted(item)}
                      key={item.colorName}
                      draggable
                    />
                  </div>
                )
                )}
              </div>
              <div><hr /></div>
              <div class="color-title">
                Sizes:
              </div>
              <div class="sizes">
                <Container>
                  <Row>
                    <Col>Size</Col>
                    <Col>Cost</Col>
                    <Col>Cost 2XL</Col>
                    <Col>Retail</Col>
                    <Col>Inv</Col>
                  </Row>

                  {currentItem && currentItem.sizes && currentItem.sizes.map && currentItem.sizes.map((size) => {
                    var inv = inventory.find(item => item.uniqueKey == size.uniqueKey);
                    if (loginStatus)
                      return (<Row key={size.sizeId || size.productId} className="align-items-center">
                        <Col>
                          {formatPantsSize(size.sizeName)}
                          {superAdmin && (
                            <Pencil
                              size={16}
                              style={{ marginLeft: 6, cursor: 'pointer', verticalAlign: 'middle' }}
                              onClick={() => openSizeOverrideModal(size)}
                            />
                          )}
                        </Col>
                        <Col>{size.cost.toLocaleString(undefined, { maximumFractionDigits: 2 })}</Col>
                        <Col>{size.price2X.toLocaleString(undefined, { maximumFractionDigits: 2 })}</Col>
                        <Col>{size.costSingle2X.toLocaleString(undefined, { maximumFractionDigits: 2 })}</Col>
                        <Col>{inv?.quantity}</Col>
                      </Row>)
                    else
                      return (
                        <div key={size.sizeId || size.productId}><Button variant="secondary" onClick={(event) => { sizeClick(event); }}>{size.sizeName}</Button></div>
                      );
                  })}

                </Container>
              </div>
              <div><hr /></div>
            </div>
          </div>
          <Button onClick={removeProduct}>Remove From Catalog</Button>
          {loginStatus && superAdmin && (
            <Button onClick={() => setCloneProductModalShow(true)}>Clone Product to Other Sites</Button>
          )}
          <br />
          <br />
          {superAdmin && (
            <Container>
              <Row className="align-items-center mb-3">
                <Col md="auto">
                  <Form.Check
                    type="switch"
                    id="hidden-switch"
                    label={hidden ? "Product is Hidden from Catalog" : "Product is Visible in Catalog"}
                    checked={hidden}
                    onChange={(event) => { hiddenChanged(event.target.checked); }}
                  />
                </Col>
                {hidden && (
                  <Col>
                    <span className="text-warning">⚠️ This product is hidden from regular users</span>
                  </Col>
                )}
              </Row>
            </Container>
          )}
          <br />
          <Modal show={sizeOverrideModalShow} onHide={closeSizeOverrideModal}>
            <Modal.Header closeButton>
              <Modal.Title>Edit Size Display Name</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {editingSize && (
                <>
                  <Form.Group className="mb-3">
                    <Form.Label>SanMar size</Form.Label>
                    <Form.Control
                      type="text"
                      value={formatPantsSize(editingSize.originalSizeName || editingSize.sizeName)}
                      disabled
                      readOnly
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Display name override</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Leave blank to use SanMar size"
                      value={editingSizeOverride}
                      onChange={(e) => setEditingSizeOverride(e.target.value)}
                    />
                    <Form.Text className="text-muted">
                      This name is shown on the site and purchase orders. SanMar always receives the original size.
                    </Form.Text>
                  </Form.Group>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeSizeOverrideModal}>
                Cancel
              </Button>
              <Button variant="primary" onClick={saveSizeOverride} disabled={sizeOverrideSaving}>
                {sizeOverrideSaving ? 'Saving...' : 'Save'}
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={show} onHide={handleSizeModalClose}>
            <Modal.Header closeButton>
              <Modal.Title>Available Sizes for<br /> {currentDragColor}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {addSizes}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleSizeModalClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleAddSizesClick}>
                Add Sizes
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={showDescription} onHide={handleDescriptionModalClose}>
            <Modal.Header closeButton>
              <Modal.Title>Description</Modal.Title>
            </Modal.Header>
            <Modal.Body>

              <ReactQuill theme="snow" value={editedHtmlDescription} onChange={setEditedHtmlDescription} />

            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleDescriptionModalClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleDescriptionModalSave}>
                Update Description
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal show={showTitle} onHide={handleTitleModalClose}>
            <Modal.Header closeButton>
              <Modal.Title>Edit Product Title</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group>
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  value={editedTitle}
                  onChange={(e) => setEditedTitle(e.target.value)}
                  placeholder="Enter product title"
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleTitleModalClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleTitleModalSave}>
                Update Title
              </Button>
            </Modal.Footer>
          </Modal>

          <AddLogoModal show={addLogoModalShow} closeModal={closeLogoModalShow} addLogo={addLogo} />
          {cloneProductModalShow && (
            <CloneProductModal show={cloneProductModalShow} closeModal={closeProductCloneModal} cloneProduct={cloneProduct} />
          )}
          {showDecorationModal && (
            <SelectDecorationsModal
              show={showDecorationModal}
              close={handleDecorationModalClose}
              confirm={handleDecorationModalConfirm}
              decorationsByLocation={decorationsByLocation}
              availableLogoSets={availableLogoSets}
              kitId={pendingNewHireKitId}
              kitName={getKitName(pendingNewHireKitId)}
            />
          )}
          {showDuplicateModal && (
            <DuplicateNHKStyleModal
              show={showDuplicateModal}
              close={handleDuplicateModalClose}
              onCreateNew={handleDuplicateModalCreateNew}
              onAddColor={handleDuplicateModalAddColor}
              existingItems={existingNHKItems}
              styleName={currentStyle?.title}
              colorName={currentColor}
            />
          )}
          {/* Kit Selection Modal */}
          <Modal show={showKitSelectModal} onHide={() => setShowKitSelectModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Select New Hire Kit</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {loadingKits ? (
                <div className="text-center"><Spinner animation="border" /></div>
              ) : availableKits.length === 0 ? (
                <p>No kits available. Please create a kit first in the New Hire Kit page.</p>
              ) : (
                <div>
                  <p>Select which kit to add this product to:</p>
                  {availableKits.map(kit => (
                    <Button
                      key={kit.id}
                      variant="outline-primary"
                      className="d-block w-100 mb-2"
                      onClick={() => addToNewHireKit(kit.id)}
                    >
                      {kit.title}
                    </Button>
                  ))}
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowKitSelectModal(false)}>
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Logo Capability Modal */}
          <Modal show={showLogoCapabilityModal} onHide={() => setShowLogoCapabilityModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Set Logo Capability Restrictions</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Only users with ANY of the selected capabilities will see products with this logo.</p>
              {selectedLogoForCapability && (
                <div style={{ marginBottom: 15, textAlign: "center" }}>
                  <img src={apiUrl + selectedLogoForCapability.decoration_logo?.imageUrl} height={60} style={{ backgroundColor: "#eee", padding: 5 }} />
                  <div style={{ fontSize: 12, color: "#666" }}>{selectedLogoForCapability.decoration_logo?.decorationName}</div>
                </div>
              )}
              <Form.Group>
                <Form.Label>Select Capabilities (leave all unchecked for no restriction)</Form.Label>
                {capabilities.map(cap => (
                  <Form.Check
                    key={cap.id}
                    type="checkbox"
                    label={cap.capabilityTitle ? cap.capabilityTitle : cap.capabilityName}
                    checked={logoCapabilityIds.includes(cap.id)}
                    onChange={() => toggleLogoCapability(cap.id)}
                  />
                ))}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowLogoCapabilityModal(false)}>Cancel</Button>
              <Button variant="primary" onClick={saveLogoCapability}>Save</Button>
            </Modal.Footer>
          </Modal>

          {/* Color Capability Modal */}
          <Modal show={showColorCapabilityModal} onHide={() => setShowColorCapabilityModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Set Color Capability Restrictions</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Only users with ANY of the selected capabilities will see products in this color.</p>
              {selectedColorForCapability && (
                <div style={{ marginBottom: 15, textAlign: "center" }}>
                  {selectedColorForCapability.squareImageName && (
                    <img src={resolveSwatchUrl(selectedColorForCapability.squareImageName)} height={60} />
                  )}
                  {selectedColorForCapability.hexColor && !selectedColorForCapability.squareImageName && (
                    <div style={{ backgroundColor: selectedColorForCapability.hexColor, width: 60, height: 60, margin: "0 auto" }}></div>
                  )}
                  <div style={{ fontSize: 12, color: "#666" }}>{selectedColorForCapability.colorName}</div>
                </div>
              )}
              <Form.Group>
                <Form.Label>Select Capabilities (leave all unchecked for no restriction)</Form.Label>
                {capabilities.map(cap => (
                  <Form.Check
                    key={cap.id}
                    type="checkbox"
                    label={cap.capabilityTitle ? cap.capabilityTitle : cap.capabilityName}
                    checked={colorCapabilityIds.includes(cap.id)}
                    onChange={() => toggleColorCapability(cap.id)}
                  />
                ))}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowColorCapabilityModal(false)}>Cancel</Button>
              <Button variant="primary" onClick={saveColorCapability}>Save</Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </div>
  );

};
export default ProductDetails;